import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';

interface ProtectedRouteWithRolesProps {
  children: React.ReactNode;
  allowedProfils: string[];
}

/**
 * Route protégée avec vérification du profil utilisateur.
 * Redirige vers /home si profil non autorisé (BUG-3 corrigé).
 */
export function ProtectedRouteWithRoles({ children, allowedProfils }: ProtectedRouteWithRolesProps) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedProfils.includes(user.profil)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
